import {useEffect} from "react";

import {usePrefersReducedMotion} from "@khan/data-prefers-reduced-motion";
import {GuideStateApi} from "@khan/guide-state";

/**
 * Update buffer response state based on other state.
 *
 * Keeps buffer/streaming setting in sync with reduce motion setting
 */
export const useBufferResponseEffect = (): void => {
    const prefersReducedMotion = usePrefersReducedMotion();

    // Keep buffer/streaming setting in sync with reduce motion setting
    useEffect(() => {
        GuideStateApi.set("bufferResponse", prefersReducedMotion);
    }, [prefersReducedMotion]);
};
